import type { Components, Theme } from '@mui/material';

export const MuiFormControl: Components<Theme>['MuiFormControl'] = {
  styleOverrides: {
    root: () => ({
      padding: '0',
      margin: '0.5rem 0',
      '& input': {
        padding: '1rem',
      },
    }),
  },
};
